import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface CollapseUniDriver extends BaseUniDriver {
  isOpen(): Promise<boolean>;
}
